const Clear = "Clear"
const LowLevelSelect = "LowLevelSelect"
const SelectAlternative = "SelectAlternative"
const SetAndMode = "SetAndMode"
const SetNxProperties = "SetNxProperties"
const GetNxProperties = "GetNxProperties"
const Unlock = "Unlock"
const Lock = "Lock"
const SelectAll = "SelectAll"
const SelectExcluded = "SelectExcluded"
const SelectPossible = "SelectPossible"
const ClearAllButThis = "ClearAllButThis"
const ToggleSelect = "ToggleSelect"
const Select = "Select"
const SelectValues = "SelectValues"
const GetAndMode = "GetAndMode"
const GetCardinal = "GetCardinal"
export { GetCardinal };
export { GetAndMode };
export { SelectValues };
export { Select };
export { ToggleSelect };
export { ClearAllButThis };
export { SelectPossible };
export { SelectExcluded };
export { SelectAll };
export { Lock };
export { Unlock };
export { GetNxProperties };
export { SetNxProperties };
export { SetAndMode };
export { SelectAlternative };
export { LowLevelSelect };
export { Clear };